import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import NoInsights from './NoInsights';
import InsightForm from './InsightForm';

const InsightFormPicker = (props) => {
  const { resource } = useMetaLayoutContext();
  const hasInsightSections = resource?.attr('facetPlanProposalScenarioInsightSections').resources().length() > 0;
  if (!hasInsightSections) {
    return <NoInsights />;
  }

  return <InsightForm {...props} />;
};

export default InsightFormPicker;
